import { LogoLockup } from './Logo';
import { Reveal } from './Reveal';

const LINKS = [
  { id: 'about', label: 'About' },
  { id: 'what-we-do', label: 'What We Do' },
  { id: 'why-us', label: 'Why Choose Us' },
  { id: 'maintenance', label: 'Maintenance' },
  { id: 'faq', label: 'FAQ' },
  { id: 'enquiry', label: 'Contact' },
];

export default function Footer({ onNavigate }) {
  return (
    <footer className="relative overflow-hidden border-t border-[#DCBC7F]/15 py-20" data-testid="footer-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col justify-between gap-12 md:flex-row md:items-start">
            <div>
              <span data-testid="footer-logo">
                <LogoLockup compact />
              </span>
              <p className="mt-5 max-w-xs text-sm font-light leading-relaxed text-[#8DAF9C]">
                Company Let specialists and corporate lodging partner. Registered in England & Wales.
              </p>
            </div>
            <nav className="grid grid-cols-2 gap-x-16 gap-y-4" data-testid="footer-nav">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => onNavigate(`#${l.id}`)}
                  className="text-left text-sm font-light text-[#C4D4C9] transition-colors duration-300 hover:text-[#DCBC7F]"
                >
                  {l.label}
                </button>
              ))}
            </nav>
            <div data-testid="footer-contact">
              <p className="mono-label text-[#DCBC7F]">Contact</p>
              <a
                href="mailto:info@thegatestays.co.uk"
                data-testid="footer-email"
                className="mt-4 block text-sm font-light text-[#C4D4C9] transition-colors duration-300 hover:text-[#DCBC7F]"
              >
                info@thegatestays.co.uk
              </a>
              <a
                href="tel:+447425688476"
                data-testid="footer-phone"
                className="mt-2 block text-sm font-light text-[#C4D4C9] transition-colors duration-300 hover:text-[#DCBC7F]"
              >
                07425 688476
              </a>
              <a
                href="https://www.thegatestays.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-website"
                className="mt-2 block text-sm font-light text-[#C4D4C9] transition-colors duration-300 hover:text-[#DCBC7F]"
              >
                www.thegatestays.co.uk
              </a>
              <p className="mt-2 text-sm font-light text-[#8DAF9C]">Covent Garden, London</p>
            </div>
          </div>
        </Reveal>
        <p
          className="font-display pointer-events-none mt-20 select-none whitespace-nowrap text-center text-[13vw] font-semibold leading-none text-[#F3E9D7]/[0.04]"
          aria-hidden="true"
        >
          THE GATE STAYS
        </p>
        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-[#DCBC7F]/10 pt-8 sm:flex-row">
          <p className="text-xs font-light text-[#8DAF9C]">© {new Date().getFullYear()} The Gate Stays Ltd. All rights reserved.</p>
          <p className="mono-label text-[#8DAF9C]">Guaranteed Rent · Zero Hassle</p>
        </div>
      </div>
    </footer>
  );
}
